/* global axios */
import ApiClient from '../ApiClient';

class OnixKnowledgeAPI extends ApiClient {
  constructor() {
    super('onix/knowledge', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  createChunk(data) {
    return axios.post(`${this.url}/chunks`, data);
  }

  retrieveTest({ collectionId, query, topK = 5 }) {
    return axios.post(`${this.url}/retrieve_test`, {
      collection_id: collectionId,
      query,
      top_k: topK,
    });
  }
}

export default new OnixKnowledgeAPI();
